//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

/* global angular: false */


/*
 * This is lifted from http://stackoverflow.com/questions/12931369/click-everywhere-but-here-event
 *
 * This directive is attached as an attribute whose value is a callback function that is
 * executed when a user clicks anywhere outside of the element to which this is attached.
 *
 * For example, say we had the following html snippet...
 *
 * <h1>Title Here</h1>
 * <div>
 *     <p>Paragraph content goes here</p>
 *     <p click-outside="someCallback()">More paragraph content goes here</p>
 * </div>
 *
 * If a user were to click on any element except the second <p> tag, the "someCallback()"
 * function would be executed.
 *
 */
(function() {
  const curalate = angular.module('curalate');

  curalate.directive('clickOutside', [
    '$document',
    '$timeout',
    function(
            $document,
            $timeout,
        ) {
      return {
        restrict: 'A',
        scope: {
          callback: '=clickOutside',
          enabled: '=clickOutsideEnabled',
        },
        link(scope, element) {
          const handler = function(event) {
            if (!element[0].contains(event.target) && scope.enabled) {
              scope.$apply(() => {
                scope.callback(event);
              });
            }
          };

                    // Defer attaching the callback to the click event until the current
                    // call stack is complete. If, for example, we are toggling the visibility
                    // of an element based on the click event, we don't want the callback
                    // click event that may have exposed the 'click-outside' element to also
                    // trigger the callback.
          $timeout(() => {
            $document.on('click', handler);
            scope.$on('$destroy', () => {
              $document.off('click', handler);
            });
          }, 0);
        },
      };
    },
  ]);
})();

